import { Meta, StoryObj } from "@storybook/nextjs-vite";
import { IndexCards } from "./IndexCards";
import { Card } from "@/types/General";
import { Spinner } from "@/icons";

const meta: Meta<typeof IndexCards> = {
  title: "Index cards",
  component: IndexCards,
  argTypes: {
    paginationType: {
      control: "select",
      options: ["infinite-scroll", "expandable-section"],
    },
    viewMoreText: {
      control: "object",
      if: { arg: "paginationType", eq: "expandable-section" },
    },
    viewLessText: {
      control: "object",
      if: { arg: "paginationType", eq: "expandable-section" },
    },
  },
};

export default meta;

export const ResourceType: StoryObj = {
  name: "Resource type",
  args: {
    paginationType: "infinite-scroll",
    isEndOfPage: false,
    isLoading: false,
    viewMoreText: {
      text: "View more",
      dld: "view more dld",
      dlt: "view more dlt",
    },
    viewLessText: {
      text: "View less",
      dld: "view less dld",
      dlt: "view less dlt",
    },
    loadingComponent: (
      <div className="mx-auto mt-8 w-fit animate-spin">
        <Spinner />
      </div>
    ),
    sections: [
      {
        text: "Featured resources",
        layoutType: "masonry",
        numberOfColumns: 2,
        predicate: (card: Card) => card.isFeatured ?? true,
      },
      {
        text: "Other resources",
        layoutType: "masonry",
        numberOfColumns: 2,
        predicate: (card: Card) => !card.isFeatured,
      },
    ],
    displayedCards: [
      {
        type: "Resource",
        resourceType: "Brochure",
        title: "Featured Title",
        description: "Description",
        isFeatured: true,
        link: {
          title: "Link",
          url: "#",
          dld: "dld",
          dlt: "dlt",
        },
      },
      {
        type: "Resource",
        resourceType: "Brochure",
        title: "Featured Title",
        description:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent ligula tortor, varius in elementum malesuada, placerat nec sem. Nullam tempus enim orci, eget imperdiet nisl aliquet ut.",
        isFeatured: true,
        link: {
          title: "Link",
          url: "#",
          dld: "dld",
          dlt: "dlt",
        },
      },
      {
        type: "Resource",
        resourceType: "Brochure",
        title: "Featured Title",
        description:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent ligula tortor, varius in elementum malesuada, placerat nec sem. Nullam tempus enim orci, eget imperdiet nisl aliquet ut.",
        isFeatured: true,
        link: {
          title: "Link",
          url: "#",
          dld: "dld",
          dlt: "dlt",
        },
      },
      {
        type: "Resource",
        resourceType: "Brochure",
        title: "Featured Title",
        description: "Description",
        isFeatured: true,
        link: {
          title: "Link",
          url: "#",
          dld: "dld",
          dlt: "dlt",
        },
        media: {
          type: "video",
          videoId: "m1s0wwmx5b",
        },
      },
      {
        type: "Resource",
        resourceType: "Brochure",
        title: "Non-featured Title",
        description: "Description",
        isFeatured: false,
        link: {
          title: "Link",
          url: "#",
          dld: "dld",
          dlt: "dlt",
        },
      },
      {
        type: "Resource",
        resourceType: "Brochure",
        title: "Non-featured Title",
        description:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent ligula tortor, varius in elementum malesuada, placerat nec sem.",
        isFeatured: false,
        link: {
          title: "Link",
          url: "#",
          dld: "dld",
          dlt: "dlt",
        },
      },
      {
        type: "Resource",
        resourceType: "Brochure",
        title: "Non-featured Title",
        description:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent ligula tortor, varius in elementum malesuada, placerat nec sem. Nullam tempus enim orci, eget imperdiet nisl aliquet ut. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent ligula tortor, varius in elementum malesuada, placerat nec sem. Nullam tempus enim orci, eget imperdiet nisl aliquet ut.",
        isFeatured: false,
        link: {
          title: "Link",
          url: "#",
          dld: "dld",
          dlt: "dlt",
        },
      },
      {
        type: "Resource",
        resourceType: "Brochure",
        title: "Non-featured Title",
        description: "Description",
        isFeatured: false,
        link: {
          title: "Link",
          url: "#",
          dld: "dld",
          dlt: "dlt",
        },
        media: {
          type: "video",
          videoId: "m1s0wwmx5b",
        },
      },
    ],
    hiddenCards: [],
  },
};

export const EventType: StoryObj = {
  name: "Event type",
  args: {
    paginationType: "infinite-scroll",
    isEndOfPage: false,
    isLoading: false,
    viewMoreText: {
      text: "View more",
      dld: "view more dld",
      dlt: "view more dlt",
    },
    viewLessText: {
      text: "View less",
      dld: "view less dld",
      dlt: "view less dlt",
    },
    loadingComponent: (
      <div className="mx-auto mt-8 w-fit animate-spin">
        <Spinner />
      </div>
    ),
    sections: [
      {
        layoutType: "stack",
        predicate: (card: Card) => card.isFeatured ?? true,
      },
      {
        layoutType: "stack",
        predicate: (card: Card) => !card.isFeatured,
      },
    ],
    displayedCards: [
      {
        fomoText: {
          upcomingText: "Don't miss it!",
          todayText: "Today",
        },
        hideDate: false,
        presenters: [],
        tier: 1,
        type: "Event",
        title: "Featured Title",
        description: "Description",
        isFeatured: true,
        categories: ["Category 1", "Category 2"],
        startDate: "Mon, 12 Jan 2026 11:55:32 GMT",
        endDate: "Mon, 19 Jan 2026 11:55:32 GMT",
        location: "Location",
        link: {
          title: "Link",
          url: "#",
          dld: "dld",
          dlt: "dlt",
        },
        media: {
          type: "image",
          image:
            "https://p1.aprimocdn.net/solarwinds/68794fd2-c70f-45a8-ba05-b39300ed8929/placeholder_image_16x9_Original%20file.png",
        },
      },
      {
        fomoText: {
          upcomingText: "Don't miss it!",
          todayText: "Today",
        },
        hideDate: false,
        presenters: [],
        tier: 1,
        type: "Event",
        title: "Featured Title",
        description:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent ligula tortor, varius in elementum malesuada, placerat nec sem. Nullam tempus enim orci, eget imperdiet nisl aliquet ut.",
        isFeatured: true,
        categories: ["Category 1", "Category 2"],
        startDate: "Mon, 12 Jan 2026 11:55:32 GMT",
        endDate: "Mon, 19 Jan 2026 11:55:32 GMT",
        location: "Location",
        link: {
          title: "Link",
          url: "#",
          dld: "dld",
          dlt: "dlt",
        },
        media: {
          type: "image",
          image:
            "https://p1.aprimocdn.net/solarwinds/68794fd2-c70f-45a8-ba05-b39300ed8929/placeholder_image_16x9_Original%20file.png",
        },
      },
      {
        fomoText: {
          upcomingText: "Don't miss it!",
          todayText: "Today",
        },
        hideDate: false,
        presenters: [],
        tier: 1,
        type: "Event",
        title: "Featured Title",
        description:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent ligula tortor, varius in elementum malesuada, placerat nec sem. Nullam tempus enim orci, eget imperdiet nisl aliquet ut.",
        isFeatured: true,
        categories: ["Category 1", "Category 2"],
        startDate: "Mon, 12 Jan 2026 11:55:32 GMT",
        endDate: "Mon, 19 Jan 2026 11:55:32 GMT",
        location: "Location",
        link: {
          title: "Link",
          url: "#",
          dld: "dld",
          dlt: "dlt",
        },
        media: {
          type: "image",
          image:
            "https://p1.aprimocdn.net/solarwinds/68794fd2-c70f-45a8-ba05-b39300ed8929/placeholder_image_16x9_Original%20file.png",
        },
      },
      {
        fomoText: {
          upcomingText: "Don't miss it!",
          todayText: "Today",
        },
        hideDate: false,
        presenters: [],
        tier: 1,
        type: "Event",
        title: "Featured Title",
        description: "Description",
        isFeatured: true,
        categories: ["Category 1", "Category 2"],
        startDate: "Mon, 12 Jan 2026 11:55:32 GMT",
        endDate: "Mon, 19 Jan 2026 11:55:32 GMT",
        location: "Location",
        link: {
          title: "Link",
          url: "#",
          dld: "dld",
          dlt: "dlt",
        },

        media: {
          type: "image",
          image:
            "https://p1.aprimocdn.net/solarwinds/68794fd2-c70f-45a8-ba05-b39300ed8929/placeholder_image_16x9_Original%20file.png",
        },
      },
      {
        fomoText: {
          upcomingText: "Don't miss it!",
          todayText: "Today",
        },
        hideDate: false,
        presenters: [],
        tier: 1,
        type: "Event",
        title: "Non-featured Title",
        description: "Description",
        isFeatured: false,
        categories: ["Category 1", "Category 2"],
        startDate: "Mon, 12 Jan 2026 11:55:32 GMT",
        endDate: "Mon, 19 Jan 2026 11:55:32 GMT",
        location: "Location",
        link: {
          title: "Link",
          url: "#",
          dld: "dld",
          dlt: "dlt",
        },
      },
      {
        fomoText: {
          upcomingText: "Don't miss it!",
          todayText: "Today",
        },
        hideDate: false,
        presenters: [],
        tier: 1,
        type: "Event",
        title: "Non-featured Title",
        description:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent ligula tortor, varius in elementum malesuada, placerat nec sem.",
        isFeatured: false,
        categories: ["Category 1", "Category 2"],
        startDate: "Mon, 12 Jan 2026 11:55:32 GMT",
        endDate: "Mon, 19 Jan 2026 11:55:32 GMT",
        location: "Location",
        link: {
          title: "Link",
          url: "#",
          dld: "dld",
          dlt: "dlt",
        },
      },
      {
        fomoText: {
          upcomingText: "Don't miss it!",
          todayText: "Today",
        },
        hideDate: false,
        presenters: [],
        tier: 1,
        type: "Event",
        title: "Non-featured Title",
        description:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent ligula tortor, varius in elementum malesuada, placerat nec sem. Nullam tempus enim orci, eget imperdiet nisl aliquet ut. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent ligula tortor, varius in elementum malesuada, placerat nec sem. Nullam tempus enim orci, eget imperdiet nisl aliquet ut.",
        isFeatured: false,
        categories: ["Category 1", "Category 2"],
        startDate: "Mon, 12 Jan 2026 11:55:32 GMT",
        endDate: "Mon, 19 Jan 2026 11:55:32 GMT",
        location: "Location",
        link: {
          title: "Link",
          url: "#",
          dld: "dld",
          dlt: "dlt",
        },
      },
      {
        fomoText: {
          upcomingText: "Don't miss it!",
          todayText: "Today",
        },
        hideDate: false,
        presenters: [],
        tier: 1,
        type: "Event",
        title: "Non-featured Title",
        description: "Description",
        isFeatured: false,
        categories: ["Category 1", "Category 2"],
        startDate: "Mon, 12 Jan 2026 11:55:32 GMT",
        endDate: "Mon, 19 Jan 2026 11:55:32 GMT",
        location: "Location",
        link: {
          title: "Link",
          url: "#",
          dld: "dld",
          dlt: "dlt",
        },
        media: {
          type: "video",
          videoId: "m1s0wwmx5b",
        },
      },
    ],

    hiddenCards: [],
  },
};

const newsroomCard = {
  type: "Newsroom",
  newsroomType: "Award",
  date: "Mon, 12 Jan 2026 11:55:32 GMT",
  title: "Default eliminates tool sprawl and accelerates issue resolution.",
  link: {
    title: "Link",
    url: "#",
    dld: "dld",
    dlt: "dlt",
  },
  media: {
    type: "image",
    image:
      "https://p1.aprimocdn.net/solarwinds/fe7b05e6-0071-4571-a052-b2f1016afa54/Placeholder_image_Original%20file.png?disable=upscale&width=1024",
  },
};

export const NewsroomType: StoryObj = {
  name: "Newsroom type",
  args: {
    paginationType: "infinite-scroll",
    isEndOfPage: false,
    isLoading: false,
    viewMoreText: {
      text: "View more",
      dld: "view more dld",
      dlt: "view more dlt",
    },
    viewLessText: {
      text: "View less",
      dld: "view less dld",
      dlt: "view less dlt",
    },
    loadingComponent: (
      <div className="mx-auto mt-8 w-fit animate-spin">
        <Spinner />
      </div>
    ),
    sections: [
      {
        layoutType: "grid",
        numberOfColumns: 3,
      },
    ],
    cards: Array.from({ length: 6 }, () => newsroomCard),
  },
};

export const IntegrationType: StoryObj = {
  name: "Integration type",
  args: {
    paginationType: "infinite-scroll",
    isEndOfPage: false,
    isLoading: false,
    viewMoreText: {
      text: "View more",
      dld: "view more dld",
      dlt: "view more dlt",
    },
    viewLessText: {
      text: "View less",
      dld: "view less dld",
      dlt: "view less dlt",
    },
    loadingComponent: (
      <div className="mx-auto mt-8 w-fit animate-spin">
        <Spinner />
      </div>
    ),
    sections: [
      {
        text: "",
        layoutType: "grid",
        numberOfColumns: 4,
        predicate: () => true,
      },
    ],
    hiddenCards: [],
    displayedCards: [
      {
        type: "Integration",
        title: "Title",
        description: "Description",
        link: {
          title: "Link",
          url: "#",
          dld: "dld",
          dlt: "dlt",
        },
      },
      {
        type: "Integration",
        title: "Title",
        description:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent ligula tortor, varius in elementum malesuada, placerat nec sem. Nullam tempus enim orci, eget imperdiet nisl aliquet ut.",
        link: {
          title: "Link",
          url: "#",
          dld: "dld",
          dlt: "dlt",
        },
      },
      {
        type: "Integration",
        title: "Title",
        description:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent ligula tortor, varius in elementum malesuada, placerat nec sem. Nullam tempus enim orci, eget imperdiet nisl aliquet ut.",
        link: {
          title: "Link",
          url: "#",
          dld: "dld",
          dlt: "dlt",
        },
        media: {
          type: "image",
          image:
            "https://p1.aprimocdn.net/solarwinds/04519448-7d05-427f-8d45-b39300eb434b/placeholder_image_1x1_square_Original%20file.png",
        },
      },
      {
        type: "Integration",
        title: "Title",
        description: "Description",
        link: {
          title: "Link",
          url: "#",
          dld: "dld",
          dlt: "dlt",
        },
        media: {
          type: "image",
          image:
            "https://p1.aprimocdn.net/solarwinds/04519448-7d05-427f-8d45-b39300eb434b/placeholder_image_1x1_square_Original%20file.png",
        },
      },
      {
        type: "Integration",
        title: "Title",
        description: "Description",
        link: {
          title: "Link",
          url: "#",
          dld: "dld",
          dlt: "dlt",
        },
      },
      {
        type: "Integration",
        title: "Title",
        description:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent ligula tortor, varius in elementum malesuada, placerat nec sem.",
        link: {
          title: "Link",
          url: "#",
          dld: "dld",
          dlt: "dlt",
        },
        media: {
          type: "image",
          image:
            "https://p1.aprimocdn.net/solarwinds/04519448-7d05-427f-8d45-b39300eb434b/placeholder_image_1x1_square_Original%20file.png",
        },
      },
      {
        type: "Integration",
        title: "Title",
        description:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent ligula tortor, varius in elementum malesuada, placerat nec sem. Nullam tempus enim orci, eget imperdiet nisl aliquet ut. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent ligula tortor, varius in elementum malesuada, placerat nec sem. Nullam tempus enim orci, eget imperdiet nisl aliquet ut.",
        link: {
          title: "Link",
          url: "#",
          dld: "dld",
          dlt: "dlt",
        },
      },
      {
        type: "Integration",
        title: "Title",
        description: "Description",
        link: {
          title: "Link",
          url: "#",
          dld: "dld",
          dlt: "dlt",
        },
        media: {
          type: "image",
          image:
            "https://p1.aprimocdn.net/solarwinds/04519448-7d05-427f-8d45-b39300eb434b/placeholder_image_1x1_square_Original%20file.png",
        },
      },
    ],
  },
};

export const DownloadType: StoryObj = {
  name: "Download type",
  args: {
    paginationType: "infinite-scroll",
    isEndOfPage: false,
    isLoading: false,
    viewMoreText: {
      text: "View more",
      dld: "view more dld",
      dlt: "view more dlt",
    },
    viewLessText: {
      text: "View less",
      dld: "view less dld",
      dlt: "view less dlt",
    },
    loadingComponent: (
      <div className="mx-auto mt-8 w-fit animate-spin">
        <Spinner />
      </div>
    ),
    sections: [
      {
        text: "Featured",
        layoutType: "grid",
        numberOfColumns: 2,
        predicate: (card: Card) => card.isFeatured ?? false,
      },
      {
        text: "Free Trials",
        layoutType: "grid",
        numberOfColumns: 2,
        predicate: (card: Card) => !card.isFeatured,
      },
    ],
    hiddenCards: [],
    displayedCards: [
      {
        type: "Download",
        title: "Title",
        description:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent ligula tortor, varius in elementum malesuada, placerat nec sem. Nullam tempus enim orci, eget imperdiet nisl aliquet ut. Nunc quis egestas mauris, eu accumsan arcu. Ut fermentum, sapien eu sagittis faucibus, tellus nunc lobortis augue, nec tincidunt ante neque non urna.",
        icon: "https://p1.aprimocdn.net/solarwinds/fe7b05e6-0071-4571-a052-b2f1016afa54/Placeholder_image_Original%20file.png?disable=upscale&width=1024",
        isFeatured: true,
        media: {
          type: "image",
          image:
            "https://p1.aprimocdn.net/solarwinds/fe7b05e6-0071-4571-a052-b2f1016afa54/Placeholder_image_Original%20file.png?disable=upscale&width=1024",
        },
        link: {
          title: "Download Free Trial",
          url: "#",
          dld: "dld",
          dlt: "dlt",
          underTitle: "Fully functional for 30 days",
        },
        secondLink: {
          title: "Quick View",
          dld: "dld",
          dlt: "dlt",
        },
        modal: (
          <div className="flex flex-col border p-4">
            <div className="flex min-h-10 items-center gap-8 pb-8">
              <span className="text-headline text-subhead-s font-bold">
                Modal Title
              </span>
              <div id="close-btn-box" className="ml-auto size-6" />
            </div>
            <p className="text-body-s text-body-primary">
              Placeholder modal content
            </p>
          </div>
        ),
      },
      {
        type: "Download",
        title: "Title",
        description:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent ligula tortor, varius in elementum malesuada, placerat nec sem. Nullam tempus enim orci, eget imperdiet nisl aliquet ut. Nunc quis egestas mauris, eu accumsan arcu. Ut fermentum, sapien eu sagittis faucibus, tellus nunc lobortis augue, nec tincidunt ante neque non urna.",
        isFeatured: false,
        media: {
          type: "image",
          image:
            "https://p1.aprimocdn.net/solarwinds/fe7b05e6-0071-4571-a052-b2f1016afa54/Placeholder_image_Original%20file.png?disable=upscale&width=1024",
        },
        link: {
          title: "Download Free Trial",
          url: "#",
          dld: "dld",
          dlt: "dlt",
          underTitle: "Fully functional for 30 days",
        },
        secondLink: {
          title: "Quick View",
          dld: "dld",
          dlt: "dlt",
        },
        modal: (
          <div className="flex flex-col border p-4">
            <div className="flex min-h-10 items-center gap-8 pb-8">
              <span className="text-headline text-subhead-s font-bold">
                Modal Title
              </span>
              <div id="close-btn-box" className="ml-auto size-6" />
            </div>
            <p className="text-body-s text-body-primary">
              Placeholder modal content
            </p>
          </div>
        ),
      },
      {
        type: "Download",
        title: "Title",
        description:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent ligula tortor, varius in elementum malesuada, placerat nec sem. Nullam tempus enim orci, eget imperdiet nisl aliquet ut. Nunc quis egestas mauris, eu accumsan arcu. Ut fermentum, sapien eu sagittis faucibus, tellus nunc lobortis augue, nec tincidunt ante neque non urna.",
        isFeatured: false,
        media: {
          type: "image",
          image:
            "https://p1.aprimocdn.net/solarwinds/fe7b05e6-0071-4571-a052-b2f1016afa54/Placeholder_image_Original%20file.png?disable=upscale&width=1024",
        },
        link: {
          title: "Download Free Trial",
          url: "#",
          dld: "dld",
          dlt: "dlt",
          underTitle: "Fully functional for 30 days",
        },
        secondLink: {
          title: "Quick View",
          dld: "dld",
          dlt: "dlt",
        },
        modal: (
          <div className="flex flex-col border p-4">
            <div className="flex min-h-10 items-center gap-8 pb-8">
              <span className="text-headline text-subhead-s font-bold">
                Modal Title
              </span>
              <div id="close-btn-box" className="ml-auto size-6" />
            </div>
            <p className="text-body-s text-body-primary">
              Placeholder modal content
            </p>
          </div>
        ),
      },
      {
        type: "Download",
        title: "Title",
        description:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent ligula tortor, varius in elementum malesuada, placerat nec sem. Nullam tempus enim orci, eget imperdiet nisl aliquet ut. Nunc quis egestas mauris, eu accumsan arcu. Ut fermentum, sapien eu sagittis faucibus, tellus nunc lobortis augue, nec tincidunt ante neque non urna.",
        isFeatured: true,
        media: {
          type: "image",
          image:
            "https://p1.aprimocdn.net/solarwinds/fe7b05e6-0071-4571-a052-b2f1016afa54/Placeholder_image_Original%20file.png?disable=upscale&width=1024",
        },
        link: {
          title: "Download Free Trial",
          url: "#",
          dld: "dld",
          dlt: "dlt",
          underTitle: "Fully functional for 30 days",
        },
        secondLink: {
          title: "Quick View",
          dld: "dld",
          dlt: "dlt",
        },
        modal: (
          <div className="flex flex-col border p-4">
            <div className="flex min-h-10 items-center gap-8 pb-8">
              <span className="text-headline text-subhead-s font-bold">
                Modal Title
              </span>
              <div id="close-btn-box" className="ml-auto size-6" />
            </div>
            <p className="text-body-s text-body-primary">
              Placeholder modal content
            </p>
          </div>
        ),
      },
      {
        type: "Download",
        title: "Title",
        description:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent ligula tortor, varius in elementum malesuada, placerat nec sem. Nullam tempus enim orci, eget imperdiet nisl aliquet ut. Nunc quis egestas mauris, eu accumsan arcu. Ut fermentum, sapien eu sagittis faucibus, tellus nunc lobortis augue, nec tincidunt ante neque non urna.",
        isFeatured: true,
        media: {
          type: "image",
          image:
            "https://p1.aprimocdn.net/solarwinds/fe7b05e6-0071-4571-a052-b2f1016afa54/Placeholder_image_Original%20file.png?disable=upscale&width=1024",
        },
        link: {
          title: "Download Free Trial",
          url: "#",
          dld: "dld",
          dlt: "dlt",
          underTitle: "Fully functional for 30 days",
        },
        secondLink: undefined,
        thirdLink: {
          title: "Learn More",
          url: "#",
          dld: "dld",
          dlt: "dlt",
        },
      },
      {
        type: "Download",
        title: "Title",
        description:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent ligula tortor, varius in elementum malesuada, placerat nec sem. Nullam tempus enim orci, eget imperdiet nisl aliquet ut. Nunc quis egestas mauris, eu accumsan arcu. Ut fermentum, sapien eu sagittis faucibus, tellus nunc lobortis augue, nec tincidunt ante neque non urna.",
        isFeatured: false,
        media: {
          type: "image",
          image:
            "https://p1.aprimocdn.net/solarwinds/fe7b05e6-0071-4571-a052-b2f1016afa54/Placeholder_image_Original%20file.png?disable=upscale&width=1024",
        },
        link: {
          title: "Download Free Trial",
          url: "#",
          dld: "dld",
          dlt: "dlt",
          underTitle: "Fully functional for 30 days",
        },
        secondLink: undefined,
        thirdLink: {
          title: "Learn More",
          url: "#",
          dld: "dld",
          dlt: "dlt",
        },
      },
    ],
  },
};

export const ProductType: StoryObj<typeof IndexCards> = {
  name: "Product type",
  args: {
    paginationType: "infinite-scroll",
    isEndOfPage: true,
    isLoading: false,
    onGoToNextPage: () => undefined,
    loadingComponent: <Spinner />,
    sections: [
      {
        text: "Monitoring & Observability",
        layoutType: "grid",
        numberOfColumns: 2,
        predicate: (card: Card) =>
          card.categorization?.some(
            (category) =>
              category.parameterName === "category" &&
              category.categories.includes("Monitoring & Observability"),
          ) ?? false,
      },
      {
        text: "IT Service Management",
        layoutType: "grid",
        numberOfColumns: 2,
        predicate: (card: Card) =>
          card.categorization?.some(
            (category) =>
              category.parameterName === "category" &&
              category.categories.includes("IT Service Management"),
          ) ?? false,
      },
    ],
    hiddenCards: [],
    displayedCards: [
      {
        type: "Product",
        title: "SolarWinds Observability SaaS",
        subhead: "Full-stack observability. No infrastructure required.",
        description:
          "Metrics, logs, traces, APM, and digital experience monitoring in a single SaaS platform built for modern cloud environments.",
        categorization: [
          {
            parameterName: "category",
            name: "Category",
            categories: ["Monitoring & Observability"],
          },
        ],
        link: {
          title: "Start Trial",
          url: "#",
          dld: "start-trial",
          dlt: "Product Card",
          underTitle: "30-day trial",
        },
        secondLink: {
          title: "Quick View",
          dld: "quick-view",
          dlt: "Product Card",
        },
        thirdLink: {
          title: "SolarWinds Observability SaaS",
          url: "#",
          dld: "solarwinds-observability-saas",
          dlt: "Product Card Title",
        },
        modal: (
          <div className="flex w-full flex-col gap-6 p-10 lg:min-w-[40rem]">
            <h2 className="text-headline text-subhead-s font-bold">
              SolarWinds Observability SaaS
            </h2>
            <p className="text-body-primary text-body-s">
              Product quick-view content
            </p>
          </div>
        ),
      },
      {
        type: "Product",
        title: "SolarWinds Observability Self-Hosted",
        subhead: "Full-stack hybrid IT observability. On your terms.",
        description:
          "One platform for networks, servers, apps, databases, and cloud, with AIOps intelligence and flexible node-based licensing.",
        categorization: [
          {
            parameterName: "category",
            name: "Category",
            categories: ["Monitoring & Observability"],
          },
        ],
        link: {
          title: "Start Trial",
          url: "#",
          dld: "start-trial",
          dlt: "Product Card",
          underTitle: "30-day trial",
        },
        secondLink: {
          title: "Quick View",
          dld: "quick-view",
          dlt: "Product Card",
        },
        thirdLink: {
          title: "SolarWinds Observability Self-Hosted",
          url: "#",
          dld: "solarwinds-observability-self-hosted",
          dlt: "Product Card Title",
        },
        modal: (
          <div className="flex w-full flex-col gap-6 p-10 lg:min-w-[40rem]">
            <h2 className="text-headline text-subhead-s font-bold">
              SolarWinds Observability Self-Hosted
            </h2>
            <p className="text-body-primary text-body-s">
              Product quick-view content
            </p>
          </div>
        ),
      },
      {
        type: "Product",
        title: "Access Rights Manager",
        subhead: "Stop access risk before it spreads.",
        description:
          "Audit, analyze, and remediate risky Active Directory and file-share permissions with automated provisioning and clear, audit-ready reports.",
        categorization: [
          {
            parameterName: "category",
            name: "Category",
            categories: ["Monitoring & Observability"],
          },
        ],
        link: {
          title: "Start Trial",
          url: "#",
          dld: "start-trial",
          dlt: "Product Card",
          underTitle: "30-day trial",
        },
        secondLink: {
          title: "Quick View",
          dld: "quick-view",
          dlt: "Product Card",
        },
        thirdLink: {
          title: "Access Rights Manager",
          url: "#",
          dld: "access-rights-manager",
          dlt: "Product Card Title",
        },
        modal: (
          <div className="flex w-full flex-col gap-6 p-10 lg:min-w-[40rem]">
            <h2 className="text-headline text-subhead-s font-bold">
              Access Rights Manager
            </h2>
            <p className="text-body-primary text-body-s">
              Product quick-view content
            </p>
          </div>
        ),
      },
      {
        type: "Product",
        title: "Security Event Manager",
        subhead: "Threats spotted. Compliance handled.",
        description:
          "Collect and correlate logs in real time with built-in threat detection and out-of-the-box compliance reporting.",
        categorization: [
          {
            parameterName: "category",
            name: "Category",
            categories: ["Monitoring & Observability"],
          },
        ],
        link: {
          title: "Start Trial",
          url: "#",
          dld: "start-trial",
          dlt: "Product Card",
          underTitle: "30-day trial",
        },
        secondLink: {
          title: "Quick View",
          dld: "quick-view",
          dlt: "Product Card",
        },
        thirdLink: {
          title: "Security Event Manager",
          url: "#",
          dld: "security-event-manager",
          dlt: "Product Card Title",
        },
        modal: (
          <div className="flex w-full flex-col gap-6 p-10 lg:min-w-[40rem]">
            <h2 className="text-headline text-subhead-s font-bold">
              Security Event Manager
            </h2>
            <p className="text-body-primary text-body-s">
              Product quick-view content
            </p>
          </div>
        ),
      },
      {
        type: "Product",
        title: "SolarWinds Service Desk",
        subhead: "Modern IT service management built for productivity.",
        description:
          "Simplify service delivery with incident, asset, and change management in an intelligent, cloud-based ITSM platform.",
        categorization: [
          {
            parameterName: "category",
            name: "Category",
            categories: ["IT Service Management"],
          },
        ],
        link: {
          title: "Start Trial",
          url: "#",
          dld: "start-trial",
          dlt: "Product Card",
          underTitle: "30-day trial",
        },
        secondLink: {
          title: "Quick View",
          dld: "quick-view",
          dlt: "Product Card",
        },
        thirdLink: {
          title: "SolarWinds Service Desk",
          url: "#",
          dld: "solarwinds-service-desk",
          dlt: "Product Card Title",
        },
        modal: (
          <div className="flex w-full flex-col gap-6 p-10 lg:min-w-[40rem]">
            <h2 className="text-headline text-subhead-s font-bold">
              SolarWinds Service Desk
            </h2>
            <p className="text-body-primary text-body-s">
              Product quick-view content
            </p>
          </div>
        ),
      },
      {
        type: "Product",
        title: "Web Help Desk",
        subhead: "Simple, affordable help desk ticketing.",
        description:
          "Automate ticket management, centralize requests, and help support teams resolve employee issues more efficiently.",
        categorization: [
          {
            parameterName: "category",
            name: "Category",
            categories: ["IT Service Management"],
          },
        ],
        link: {
          title: "Start Trial",
          url: "#",
          dld: "start-trial",
          dlt: "Product Card",
          underTitle: "30-day trial",
        },
        secondLink: {
          title: "Quick View",
          dld: "quick-view",
          dlt: "Product Card",
        },
        thirdLink: {
          title: "Web Help Desk",
          url: "#",
          dld: "web-help-desk",
          dlt: "Product Card Title",
        },
        modal: (
          <div className="flex w-full flex-col gap-6 p-10 lg:min-w-[40rem]">
            <h2 className="text-headline text-subhead-s font-bold">
              Web Help Desk
            </h2>
            <p className="text-body-primary text-body-s">
              Product quick-view content
            </p>
          </div>
        ),
      },
    ],
  },
};
